import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';

import { DataAccessEventsPageFacade, DataAccessFairsFacade } from '@planone/bau365/data-access-fair-data';
import { ShareButtonClickEventType, ShareDialogOpenEventType } from '@planone/bau365/feature-tracking';
import { Event as EventInterface, Exhibitor } from '@planone/bau365/util-fair-data';
import { BreadcrumbElement, ModalBottomsheetHelper, ModalBottomsheetType } from '@planone/shared/ui-elements';
import { ImageFileTypes } from '@planone/shared/util-pipelines';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'bau365-event-section-header',
  templateUrl: './section-header.component.html',
  styleUrls: ['./section-header.component.scss'],
})
export class SectionHeaderComponent implements OnInit, OnDestroy {
  @Input() event?: EventInterface;
  @Input() exhibitor?: Exhibitor;
  @Input() breadcrumbElements?: BreadcrumbElement[] | undefined;
  @Input() socialShareUrl?: string | undefined;
  @Input() size?: string | null | undefined;
  @Input() emailSubject = '';
  @Input() emailBody = '';

  @Output() shareDialogOpened: EventEmitter<ShareDialogOpenEventType> = new EventEmitter<ShareDialogOpenEventType>();
  @Output() shareDialogClicked: EventEmitter<ShareButtonClickEventType> = new EventEmitter<ShareButtonClickEventType>();

  @ViewChild('shareButtonsTitle') public shareButtonsTitle: TemplateRef<never> | null | undefined;
  @ViewChild('shareButtons') public shareButtons: TemplateRef<never> | null | undefined;

  private unsubscribe: Subject<void> = new Subject<void>();

  timezone?: string;

  ImageFileTypes = ImageFileTypes;

  constructor(
    private EventsPageFacade: DataAccessEventsPageFacade,
    private FairsFacade: DataAccessFairsFacade,
    private modalBottomsheetHelper: ModalBottomsheetHelper
  ) {}

  ngOnInit() {
    this.FairsFacade.fairConfig$.pipe(takeUntil(this.unsubscribe)).subscribe((fair) => (this.timezone = fair.timezone));
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  openShareButtonDialog(event: Event) {
    event.preventDefault();
    event.stopPropagation();

    if (this.event) {
      this.EventsPageFacade.shareDialogOpened('EVENT', 'event-details', this.event.fair_id, this.event);

      this.shareDialogOpened.emit({
        entityType: 'EVENT',
        pageType: 'event-details',
        context: this.event.fair_id,
      });
    }

    this.modalBottomsheetHelper.openDialog(
      ModalBottomsheetType.share,
      this.shareButtonsTitle,
      this.shareButtons,
      this.size ?? undefined
    );
  }

  shareButtonClick(network: string) {
    if (this.event && this.exhibitor) {
      this.EventsPageFacade.shareButtonClicked(
        network,
        this.event,
        this.exhibitor,
        'event-details',
        this.event.fair_id
      );

      this.shareDialogClicked.emit({
        entityType: 'EVENT',
        pageType: 'event-details',
        context: this.event.fair_id,
        network: network,
      });
    }
  }
}
